import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "bg-white min-h-screen flex flex-col justify-between" }
const _hoisted_2 = { class: "bg-black text-white rounded-xl mx-2 sm:mx-4 mt-2 sm:mt-4 pr-2 sm:pr-4 md:pr-6 lg:pr-8 lg:pl-0" }
const _hoisted_3 = { class: "mx-auto flex justify-between items-center py-2 sm:py-4" }
const _hoisted_4 = { class: "hidden md:flex space-x-6 lg:space-x-8 text-xl lg:text-2xl items-center" }
const _hoisted_5 = { class: "md:hidden pr-2 sm:pr-3" }
const _hoisted_6 = {
  key: 0,
  class: "rounded-xl bg-black bg-opacity-95 text-white flex flex-col space-y-4 px-4 sm:px-10 w-[95%] py-4 md:hidden"
}
const _hoisted_7 = { class: "bg-black bg-opacity-95 text-white py-3 sm:py-4 text-center text-sm sm:text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LucideHome = _resolveComponent("LucideHome")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LucideSearch = _resolveComponent("LucideSearch")!
  const _component_LucideDatabase = _resolveComponent("LucideDatabase")!
  const _component_LucideBarChart3 = _resolveComponent("LucideBarChart3")!
  const _component_LucideMenu = _resolveComponent("LucideMenu")!
  const _component_LucideX = _resolveComponent("LucideX")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"flex items-center space-x-2 active:text-[#34dc1c] sm:space-x-3\" data-v-80c27e16><div class=\"w-[68px] sm:w-[85px] h-15 sm:h-15\" data-v-80c27e16><img src=\"" + _imports_0 + "\" alt=\"Neuron Logo\" class=\"h-full object-contain\" data-v-80c27e16></div><div class=\"font-bold capitalize\" data-v-80c27e16><strong class=\"text-2xl sm:text-3xl md:text-5xl lg:text-6xl block\" data-v-80c27e16>Neuron</strong><span class=\"text-sm sm:text-lg md:text-xl lg:text-xl font-normal block\" data-v-80c27e16> The brain of your analytics workflow </span></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            "active-class": "text-[#157813]",
            "exact-active-class": "text-[#157813] border-b-2 border-[#157813]",
            class: "text-white hover:text-[#157813] transition-all duration-200 flex items-center space-x-2 pb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LucideHome, { class: "w-5 h-5" }),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Home", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/advanced-search",
            "active-class": "text-[#157813]",
            "exact-active-class": "text-[#157813] border-b-2 border-[#157813]",
            class: "text-white hover:text-[#157813] transition-all duration-200 flex items-center space-x-2 pb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LucideSearch, { class: "w-5 h-5" }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Advanced Search", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/queries",
            "active-class": "text-[#157813]",
            "exact-active-class": "text-[#157813] border-b-2 border-[#157813]",
            class: "text-white hover:text-[#157813] transition-all duration-200 flex items-center space-x-2 pb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LucideDatabase, { class: "w-5 h-5" }),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "Feature Store", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/summary",
            "active-class": "text-[#157813]",
            "exact-active-class": "text-[#157813] border-b-2 border-[#157813]",
            class: "text-white hover:text-[#157813] transition-all duration-200 flex items-center space-x-2 pb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LucideBarChart3, { class: "w-5 h-5" }),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Summary", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args))),
            class: "focus:outline-none p-2",
            "aria-label": "Toggle menu"
          }, [
            (!_ctx.isMobileMenuOpen)
              ? (_openBlock(), _createBlock(_component_LucideMenu, {
                  key: 0,
                  class: "w-6 h-6"
                }))
              : (_openBlock(), _createBlock(_component_LucideX, {
                  key: 1,
                  class: "w-6 h-6"
                }))
          ])
        ])
      ]),
      (_ctx.isMobileMenuOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/",
              "active-class": "text-[#157813]",
              "exact-active-class": "text-[#157813] bg-[#157813]/5 rounded-lg",
              class: "hover:text-[#157813] hover:bg-[#157813]/5 flex items-center space-x-2 p-2 transition-all duration-200 rounded-lg",
              onClick: _ctx.closeMobileMenu
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LucideHome, { class: "w-5 h-5" }),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Home", -1))
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_router_link, {
              to: "/advanced-search",
              "active-class": "text-[#157813]",
              "exact-active-class": "text-[#157813] bg-[#157813]/5 rounded-lg",
              class: "hover:text-[#157813] hover:bg-[#157813]/5 flex items-center space-x-2 p-2 transition-all duration-200 rounded-lg",
              onClick: _ctx.closeMobileMenu
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LucideSearch, { class: "w-5 h-5" }),
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "Advanced Search", -1))
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_router_link, {
              to: "/queries",
              "active-class": "text-[#157813]",
              "exact-active-class": "text-[#157813] bg-[#157813]/5 rounded-lg",
              class: "hover:text-[#157813] hover:bg-[#157813]/5 flex items-center space-x-2 p-2 transition-all duration-200 rounded-lg",
              onClick: _ctx.closeMobileMenu
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LucideDatabase, { class: "w-5 h-5" }),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Feature Store", -1))
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_router_link, {
              to: "/summary",
              "active-class": "text-[#157813]",
              "exact-active-class": "text-[#157813] bg-[#157813]/5 rounded-lg",
              class: "hover:text-[#157813] hover:bg-[#157813]/5 flex items-center space-x-2 p-2 transition-all duration-200 rounded-lg",
              onClick: _ctx.closeMobileMenu
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LucideBarChart3, { class: "w-5 h-5" }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Summary", -1))
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("footer", _hoisted_7, [
      _createElementVNode("p", null, "© " + _toDisplayString(_ctx.currentYear) + " The Neuron. all Rights Reserved", 1)
    ])
  ]))
}